var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCustomerProfile48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E4EFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.3333,
    stroke: "#202020",
    strokeOpacity: 0.03,
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2544 12C28.3992 12 31.4544 15.0528 31.4544 19.2C31.4544 23.3472 28.3992 26.4 24.2544 26.4C20.112 26.4 17.0544 23.3472 17.0544 19.2C17.0544 15.0528 20.112 12 24.2544 12ZM12 35.4528C14.1528 32.2848 17.7432 30.1728 21.8544 30.1728H26.6544C30.768 30.1728 34.356 32.2848 36.5088 35.4528C33.4416 38.736 29.0904 40.8 24.2544 40.8C19.4184 40.8 15.0672 38.736 12 35.4528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCustomerProfile48);
export default __webpack_public_path__ + "static/media/default_customer_profile_48.057ae53590a2b18959a815b65c5ff45f.svg";
export { ForwardRef as ReactComponent };